import type { ForbiddenRepositoryArgs } from '@this/domain/organization/organization3';

export type LimitTypeSummaryResponseArgs = {
  business_days: number;
  hour: number;
};

export type ArrangementRequestLimitSummaryResponseArgs = {
  premium_support: boolean;
  shinkansen: LimitTypeSummaryResponseArgs | null;
  domestic_air: LimitTypeSummaryResponseArgs | null;
  hotel: LimitTypeSummaryResponseArgs | null;
  package: LimitTypeSummaryResponseArgs | null;
  railway_package: LimitTypeSummaryResponseArgs | null;
  rental_car: LimitTypeSummaryResponseArgs | null;
  forbidden_repositories: ForbiddenRepositoryArgs[];
};

export type LimitTypeSummary = {
  businessDays: number;
  hour: number;
};

export type ArrangementRequestLimitSummary = {
  premiumSupport: boolean;
  shinkansen: LimitTypeSummary | null;
  domesticAir: LimitTypeSummary | null;
  hotel: LimitTypeSummary | null;
  package: LimitTypeSummary | null;
  railwayPackage: LimitTypeSummary | null;
  rentalCar: LimitTypeSummary | null;
  forbiddenRepositories: ForbiddenRepositoryArgs[];
};

const convertLimit = (limit: LimitTypeSummaryResponseArgs | null): LimitTypeSummary | null =>
  limit ? { businessDays: limit.business_days, hour: limit.hour } : null;

export const convertArrangementRequestLimitSummaryResponseToArgs = (
  response: ArrangementRequestLimitSummaryResponseArgs
): ArrangementRequestLimitSummary => ({
  premiumSupport: response.premium_support,
  shinkansen: convertLimit(response.shinkansen),
  domesticAir: convertLimit(response.domestic_air),
  hotel: convertLimit(response.hotel),
  package: convertLimit(response.package),
  railwayPackage: convertLimit(response.railway_package),
  rentalCar: convertLimit(response.rental_car),
  forbiddenRepositories: response.forbidden_repositories
});
